import React from 'react'
import { Box, Button, Text } from 'pcln-design-system'

const Reset = ({ resetHandler }) => {
  return (
    <Box>
      <Button onClick={resetHandler} variation='link'>
        <Text fontWeight='bold'>Reset</Text>
      </Button>
    </Box>
  )
}

export { Reset }
